import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { PlayerProvider } from './contexts/PlayerContext';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import AlbumDetail from './components/AlbumDetail';
import HistoryPage from './components/HistoryPage';
import FavoritesPage from './components/FavoritesPage';
import Player from './components/Player';
import MiniPlayer from './components/MiniPlayer';
import Shortcuts from './components/Shortcuts';
import ErrorBoundary from './components/ErrorBoundary';

import './App.css';

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user } = useAuth();
  return user ? <>{children}</> : <Navigate to="/login" />;
};

function App() {
  const [showMiniPlayer, setShowMiniPlayer] = React.useState(false);

  return (
    <ErrorBoundary>
      <AuthProvider>
        <PlayerProvider>
          <Router>
            <div className="App">
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/" element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                } />
                <Route path="/album/:id" element={
                  <ProtectedRoute>
                    <AlbumDetail />
                  </ProtectedRoute>
                } />
                <Route path="/history" element={
                  <ProtectedRoute>
                    <HistoryPage />
                  </ProtectedRoute>
                } />
                <Route path="/favorites" element={
                  <ProtectedRoute>
                    <FavoritesPage />
                  </ProtectedRoute>
                } />
              </Routes>
              <Player />
              <MiniPlayer show={showMiniPlayer} onClose={() => setShowMiniPlayer(false)} />
              <Shortcuts />
            </div>
          </Router>
        </PlayerProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;